import React from 'react';

/**
 * A member's face in the lounge: their card, shrunk to a token.
 *
 * Deliberately card-shaped rather than a circle of initials. A bare number
 * makes members feel processed; the card is an object with standing on it, so
 * the same pseudonymity that protects them also reads as belonging. See
 * docs/community_design.md §4.1a.
 *
 * Colours are fixed, exactly as on the real card (obsidian and patinated
 * gold since 2.0), so a member is the same object wherever it appears. The
 * number only -- never the display name the full card carries.
 */
const MemberToken = ({ memberNo, size = 'sm' }) => {
  const label = memberNo == null ? '—' : String(memberNo).padStart(3, '0');
  const big = size === 'lg';

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-md ${big ? 'w-12 h-12' : 'w-9 h-9'}`}
      style={{
        background: 'linear-gradient(150deg, #16191A 0%, #0E1011 55%, #07090A 100%)',
        border: '1px solid rgba(211,175,104,0.75)',
        boxShadow: 'inset 0 1px 2px rgba(255,255,255,0.08)',
      }}
      title={`No. ${label}`}
      data-testid={`member-token-${label}`}
    >
      <span
        className={`font-heading tabular-nums leading-none ${big ? 'text-base' : 'text-xs'}`}
        style={{ color: '#E8D2A6' }}
      >
        {label}
      </span>
    </span>
  );
};

export default MemberToken;
